import { Component } from '@angular/core';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import { DateFormat } from '@lsq-frontend/common-ui';
import { AuditService } from '@lsq-frontend/remote-services/ar-app';
import { BehaviorSubject } from 'rxjs';
import { DrApplicationService } from '../../service/dr-application-service';

@Component({
    selector: 'dr-audit',
    templateUrl: './dr-audit.component.html',
    styleUrls: ['./dr-audit.component.scss']
})
export class DynamicAudit {
    public data: [];
    public static defaultTake = 25;
    public rowsRaw: any = [];
    public rows = new BehaviorSubject<[]>([]);
    public loading = new BehaviorSubject<boolean>(false);
    public totalCount = new BehaviorSubject<number>(0);
    public skip = new BehaviorSubject<number>(0);
    public take = new BehaviorSubject<number>(DynamicAudit.defaultTake);

    public dateFormat = DateFormat;

    constructor(private _auditService: AuditService, private _arService: DrApplicationService) {}

    public async ngOnInit(): Promise<void> {
        this.loadFieldValue();
    }

    public tableDataSource = new LsqListSource({
        rows$: this.rows,
        loading$: this.loading,
        totalCount$: this.totalCount,
        take: this.take.value,
        skip: this.skip.value
    });

    public async loadFieldValue(): Promise<void> {
        this.loading.next(true);
        const prospectId = this._arService.getProspect().id;
        const getAuditByProspect = this._auditService.getAuditByProspect(prospectId);
        const auditByProspectData = await getAuditByProspect.toPromise();

        let localFieldValue = this.rowsRaw;
        if (localFieldValue.length === 0) {
            for (const value of auditByProspectData) {
                localFieldValue.push(value);
            }
        }
        this.rowsRaw = localFieldValue;
        this.totalCount.next(auditByProspectData.length);
        this.rows.next(this.rowsRaw);
        this.loading.next(false);
    }
}
